import { render } from "./LanguagesView.vue?vue&type=template&id=2bdb1786&scoped=true&ts=true"
import script from "./LanguagesView.vue?vue&type=script&lang=ts"
export * from "./LanguagesView.vue?vue&type=script&lang=ts"

import "./LanguagesView.vue?vue&type=style&index=0&id=2bdb1786&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bdb1786"]])

export default __exports__